import pendingBookingPage from "./pendingBooking.component";
import pendingBookingUrls from "./pendingBooking.urls";

const pendingBookingModule = angular
  .module("app.components.pendingBookings", [])
  .component("pendingBookingsPage", pendingBookingPage)
  .config(pendingBookingUrls);

export default pendingBookingModule;



// WEBPACK FOOTER //
// ./src/pages/pendingBooking/pendingBooking.module.js